<div class="container">
    <p>Something went wrong on our end. Please try again later.</p>
    <a class="linkstyle"  (click)="loginbtnclick()">Go to Homepage</a>
  </div>
  